export default {"src":"/_next/static/media/deco_checkout_paypal.13e56c9c.svg","height":22,"width":85,"blurWidth":0,"blurHeight":0};